/**
 * Represents the key codes for various keyboard keys.  Useful for detecting
 * keydown events.
 *
 * @const {object}
 */
export const KEY_CODES = {
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  ARROW_UP: 38,
  ENTER: 13,
  TAB: 9,
  ESC: 27
};

/**
 * Array of all arrow key codes
 *
 * @type {number[]}
 */
export const KEY_CODES__ARROWS = [
  KEY_CODES.ARROW_DOWN,
  KEY_CODES.ARROW_LEFT,
  KEY_CODES.ARROW_RIGHT,
  KEY_CODES.ARROW_UP,
];

/**
 * Array of just up and down arrow key codes
 *
 * @type {number[]}
 */
export const KEY_CODES__ARROWS_UP_AND_DOWN = [
  KEY_CODES.ARROW_DOWN,
  KEY_CODES.ARROW_UP,
];
